export const cards = [
    { id: 1, name: 'Nikkita Holder', titles: ['Olympian' ,'Head Coach', 'Elementary Kids Program'], image: '/images/creatives/team-1.png'},
    { id: 2, name: 'Clive Foster', titles: ['Head Coach', 'High School Boys', 'Certified IAAF LEVEL 2'], image: '/images/icons/male.svg'},   
    { id: 3, name: 'Gavin Smellie', titles: ['Olympian', 'Sprints Coach'], image: '/images/creatives/team-4.png'}
];